import React, { useState, useEffect, useCallback } from 'react'
import { Button, Col, Dropdown, Form, Image, Input, Modal, Row, Space, Table, Tooltip, Typography } from 'antd'
import { FilterFilled, MoreOutlined, PlusOutlined, ReloadOutlined } from '@ant-design/icons';
import { useAuthContext } from 'contexts/Auth'
import { useNavigate } from 'react-router-dom'
import { PDFDownloadLink, PDFViewer } from '@react-pdf/renderer';
import axios from 'axios';
import PDF from './PDF';
import ExpandedData from './ExpandedData'
import FilteredModal from './filteredModal';

const { Title } = Typography

const initialFilteredState = {
    perPage: 10,
    pageNo: 1,
    totalPage: 0,
    isModal: false,
    registrationNumber: "",
    fullName: "",
    phone: "92",
    campusId: null,
    email: "",
    cnic: "",
    sortOrder: "latest",
}

const All = () => {

    const { user, getApiConfig } = useAuthContext()

    const [form] = Form.useForm()

    const [documents, setDocuments] = useState([])
    const [filtered, setFiltered] = useState(initialFilteredState)
    const [shouldFetch, setShouldFetch] = useState(true)
    const [isLoading, setIsLoading] = useState(true)
    const [status] = useState("active")
    const [student, setStudent] = useState({})
    const [isAdmissionFormModalOpen, setIsAdmissionFormModalOpen] = useState(false)
    const [isPasswordModal, setIsPasswordModal] = useState(false)
    const [isProcessing, setIsProcessing] = useState(false)

    // const [filteredDocuments, setFilteredDocuments] = useState([])
    // const [searchText, setSearchText] = useState('')
    // const [selectedDocuments, setSelectedDocuments] = useState([])

    const navigate = useNavigate()

    // const handleSearch = e => {
    //     const value = e.target.value.toLowerCase()
    //     setSearchText(value)

    //     const searchableColumns = columns
    //         .filter((col) => col.search !== false) // Include columns where search is true or undefined
    //         .map((col) => col.dataIndex)

    //     const filtered = documents.filter((item) =>
    //         searchableColumns.some(
    //             (key) => item[key] && item[key].toString().toLowerCase().includes(value)
    //         )
    //     )

    //     setFilteredDocuments(filtered)
    // }

    const { pageNo, perPage, campusId, cnic, phone, fullName, registrationNumber, email, sortOrder } = filtered

    const readDocuments = useCallback(async () => {
        setIsLoading(true)
        axios.get(`${window.api}/students/all?status=${status}&pageNo=${pageNo}&perPage=${perPage}&searchCampusId=${campusId}&searchCNIC=${cnic}&searchPhone=${phone}&searchName=${fullName}&searchRegNo=${registrationNumber}&searchEmail=${email}&sortOrder=${sortOrder}`, getApiConfig())
            .then((res) => {
                const { data, status } = res
                if (status === 200) {
                    const array = data.students.map(student => ({ ...student, key: student.uid }))
                    setDocuments(array)
                    // setFilteredDocuments(array)
                    setFiltered(s => ({ ...s, pageNo: data.pagination.pageNo, perPage: data.pagination.perPage, totalPage: data.pagination.totalCount }))
                }
            })
            .catch(error => {
                console.error(error)
                window.toastify(error.response?.data?.message || "Something went wrong while getting the students", "error")
            })
            .finally(() => {
                setIsLoading(false)
                setShouldFetch(false)
            })
    }, [getApiConfig, status, pageNo, perPage, campusId, cnic, fullName, registrationNumber, email, sortOrder, phone])

    useEffect(() => { if (shouldFetch) { readDocuments() } }, [shouldFetch, readDocuments])

    const sendSMS = async (formData) => {

        let { fullName, phone, registrationNumber } = formData
        let msg = `Dear ${fullName}, Thank you for choosing CoDev ${window.campusName}. You have all the rights to be happy for being a part of our campus. Your registration number is ${registrationNumber}.`

        const { REACT_APP_TELENOR_API_END_POINT, REACT_APP_TELENOR_LOGIN_ID, REACT_APP_TELENOR_LOGIN_PASSWORD } = process.env
        let sessionId;
        await axios.get(`${REACT_APP_TELENOR_API_END_POINT}/auth.jsp?msisdn=${REACT_APP_TELENOR_LOGIN_ID}&password=${REACT_APP_TELENOR_LOGIN_PASSWORD}`)
            .then((res) => {
                console.log('res', res)
                sessionId = window.getDataFromHTML(res.data, "data");
            })
            .catch(err => {
                console.error(err)
                window.toastify("Something went wrong while getting session ID.", "error")
            })
        if (sessionId) {
            await axios.get(`${REACT_APP_TELENOR_API_END_POINT}/sendsms.jsp?session_id=${sessionId}&to=${phone}&text=${msg}&mask=AlSeeraht`)
                .then((res) => {
                    let status = window.getDataFromHTML(res.data, "response");
                    if (status === "OK") {
                        window.toastify("SMS successfully sent", "success")
                    } else {
                        window.toastify("SMS not sent", "error")
                    }
                })
                .catch(err => {
                    console.error(err)
                    window.toastify("Something went wrong, We couldn't send SMS. Please contact support team.", "error")
                })
        }
    }
    const sendWhatsApp = async (formData) => {

        const { fullName, whatsapp, campus, registrationNumber } = formData
        const msg = `Dear ${fullName}, Thank you for choosing CoDev ${campus.name}. You have all the rights to be happy for being a part of our campus. Your registration number is ${registrationNumber}.`

        const url = `https://wa.me/${whatsapp}?text=${msg}`
        window.open(url, "_blank")
    }

    const inviteViaEmail = (formData) => {

        const { fullName, email, uid, campus } = formData

        const url = `${window.origin}/auth/create-account/?email=${email}&id=${uid}&campus=${campus.id}`
        let data = { ...formData, url }

        const msg = {
            to: `salaam@umairahmad.net`,
            subject: `Invitation message from ${window.appName}`,
            text: `Salaam ${fullName}`,
            data
        };
        axios.post(`${window.api}/students/send-email-invitation`, msg, getApiConfig())
            .then(res => {
                const { status } = res
                if (status === 200) {
                    window.toastify("Email successfully sent", "success")
                }
            })
            .catch(err => {
                console.error(err)
                window.toastify("Something went wrong, We couldn't send email. Please contact support team.", "error")
            })
    }

    const getAdmissionForm = data => {
        setStudent(data)
        setIsAdmissionFormModalOpen(true)
    }

    const handleChangePassword = data => {
        setIsPasswordModal(true)
        setStudent(data)
    }

    const handlePasswordSubmit = (values) => {
        let { newPassword, confirmPassword } = values;

        if (newPassword !== confirmPassword) window.toastify("Please enter correct password in both field", "error")

        let formData = { newPassword, uid: student.uid }

        setIsProcessing(true)
        axios.patch(`${window.api}/auth/user-change-password`, formData, getApiConfig())
            .then((res) => {
                const { data, status } = res
                if (status === 200) {
                    window.toastify(data.message, "success")
                    setIsPasswordModal(false)
                    setStudent({})
                }
            })
            .catch(error => {
                console.error(error)
                window.toastify(error.response?.data?.message || "Something went wrong changing password", "error")
            })
            .finally(() => {
                setIsProcessing(false)
            })
    }

    // Filter Modal Close Function...
    const handleClose = () => {
        setFiltered(s => ({ ...s, isModal: false }))
    }

    // Filter Donations Function...
    const handleFilterStudents = () => {
        setFiltered(s => ({ ...s, isModal: false, pageNo: 1, perPage: 10 }))
        setShouldFetch(true)
    }

    // Refresh Function...
    const handleRefresh = () => {
        setFiltered(initialFilteredState)
        setShouldFetch(true)
    }

    // const handleDeleteSelected = () => {
    //     console.log(selectedDocuments)
    // }

    // const hasSelected = selectedDocuments.length > 0;

    const columns = [
        {
            title: 'Image',
            render: (item, row) => <Image src={row.photoURL} alt={row.fullName} className="rounded-circle" style={{ width: 48, height: 48 }} />,
        },
        { title: 'Registration#', dataIndex: 'registrationNumber', },
        { title: 'Name', dataIndex: 'fullName', },
        { title: 'CNIC', dataIndex: 'cnic', hidden: true },
        { title: 'Father CNIC', dataIndex: 'fatherCNIC', hidden: true },
        { title: 'Mother CNIC', dataIndex: 'motherCNIC', hidden: true },
        {
            title: 'Age', dataIndex: 'age',
            // defaultSortOrder: 'descend', // sorter: (a, b) => a.age - b.age,
        },
        {
            title: 'Email', dataIndex: 'email', hidden: true,
            // render: (item, row) => <a href={`mailto:${item}`} target="_blank" rel="noopener noreferrer">{item}</a>
        },
        {
            title: 'Phone', dataIndex: 'phone',
            render: (item, row) => <a href={`tel:+${item}`} target="_blank" rel="noopener noreferrer">{item}</a>
        },
        {
            title: 'WhatsApp', dataIndex: 'whatsapp',
            render: (item, row) => <a href={`https://wa.me/${item}`} target="_blank" rel="noopener noreferrer">{item}</a>
        },
        {
            title: 'Campus', dataIndex: 'campus',
            render: (item, row) => <span>{row.campus.name}</span>,
            allowedroles: ["superAdmin"]
        },
        {
            title: 'Action',
            render: (_, row) => (
                <Dropdown
                    menu={{
                        items: [
                            { label: "Edit", onClick: () => { navigate(`/dashboard/students/${row.cnic}`) } },
                            { label: "Send SMS", onClick: () => { sendSMS(row) } },
                            { label: "Send WhatsApp", onClick: () => { sendWhatsApp(row) } },
                            { label: "Invite", onClick: () => { inviteViaEmail(row) } },
                            { label: "Get Admission Form", onClick: () => { getAdmissionForm(row) } },
                            { label: "Change Password", onClick: () => { handleChangePassword(row) } },
                        ]
                    }}
                    trigger={['click']}
                >
                    <MoreOutlined className='text-primary' />
                </Dropdown>
            ),
        },
    ]

    const pdf = <PDF data={student} />

    return (
        <>
            <Row className='mb-3'>
                <Col>
                    <Title level={3} className="mb-0">Students</Title>
                </Col>
            </Row>
            <Row>
                <Col span={24}>
                    <div className="card">
                        <Row className='mb-3'>
                            <Col span={24} className="d-flex justify-content-end align-items-center">
                                <Space size="small">
                                    {/* <Input placeholder="Search..." value={searchText} onChange={handleSearch} /> */}
                                    {/* {hasSelected ? <Text>Selected: {selectedDocuments.length}</Text> : ""}
                                    <Tooltip title="Delete Students"><Button type='primary' danger disabled={!hasSelected} onClick={handleDeleteSelected}>Delete</Button></Tooltip> */}
                                    <Tooltip title="Filter Applications"><Button icon={<FilterFilled />} onClick={() => setFiltered(s => ({ ...s, isModal: true }))} /></Tooltip>
                                    <Tooltip title="Refresh Students"><Button icon={<ReloadOutlined />} onClick={handleRefresh} /></Tooltip>
                                    <Tooltip title="Add Student"><Button type='primary' icon={<PlusOutlined />} onClick={() => { navigate("/dashboard/students/add") }} /></Tooltip>
                                </Space>
                            </Col>
                        </Row>

                        <Table
                            columns={columns.filter((item) => !item.allowedroles || user.roles?.find(role => item.allowedroles?.includes(role)))}
                            dataSource={documents}
                            loading={isLoading}
                            scroll={{ x: true }}
                            size="small"
                            // rowSelection={{
                            //     onChange: (keys, rows) => setSelectedDocuments(rows)
                            // }}
                            pagination={{
                                showSizeChanger: true,
                                total: filtered.totalPage,
                                pageSize: filtered.perPage,
                                current: filtered.pageNo,
                                onChange: (pagination) => { setFiltered(s => ({ ...s, pageNo: pagination })); setShouldFetch(true) },
                                onShowSizeChange: (_, size) => { setFiltered((s) => ({ ...s, perPage: size })); setShouldFetch(true) },
                            }}
                            expandable={{
                                expandedRowRender: (row) => <ExpandedData data={row} />,
                                // rowExpandable: (row) => row.registrationNumber !== 1,
                            }}
                        />
                    </div>
                </Col>
            </Row>

            <FilteredModal open={filtered.isModal} filtered={filtered} setFiltered={setFiltered} handleFilterStudents={handleFilterStudents} handleClose={handleClose} />

            <Modal title="Admission Form" centered open={isAdmissionFormModalOpen} onCancel={() => setIsAdmissionFormModalOpen(false)} footer={null}>
                <PDFViewer width="100%" height="710">{pdf}</PDFViewer>

                <PDFDownloadLink document={pdf} fileName={`${window.appName} Admission Form - ${student.firstName} - ${student.campus?.name}`}>
                    {({ blob, url, loading, error }) => <Button type='primary' block loading={loading}>Download Form</Button>}
                </PDFDownloadLink>
            </Modal>

            <Modal centered open={isPasswordModal}
                onClose={() => { setStudent({}); setIsPasswordModal(false) }}
                onCancel={() => { setStudent({}); setIsPasswordModal(false) }}
                footer={false} width={650}
            >
                <Form layout='vertical' form={form} onFinish={handlePasswordSubmit} >
                    <Row gutter={12} >
                        <Col xs={24}><Title level={5} className='text-center d-block py-2' >Change Password</Title></Col>
                        <Col xs={24} sm={12}>
                            <Form.Item name='newPassword' label='New Password' rules={[{ required: true, min: 6, message: "Password should be consist on 6 character" }]} >
                                <Input.Password placeholder='New Password' />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} >
                            <Form.Item name='confirmPassword' label='Confirm Password' rules={[{ required: true, min: 6, message: "Password should be consist on 6 character" }]} >
                                <Input.Password placeholder='New Password' />
                            </Form.Item>
                        </Col>
                        <Col xs={24}>
                            <Form.Item className='mb-0 text-center' >
                                <Button type='primary' className='w-50' htmlType='submit' loading={isProcessing} >Confirm</Button>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Modal>
        </>
    )
}

export default All